<template>
    <el-aside :width="asideWidth">
        <el-menu
            :class="{ 'el-menu-side-nav': true, 'collapsed': collapsed}"
            :collapse="collapsed"
            :collapse-transition="false"
            :router="true"
            @select="collapseMenuIfMobile()"
        >
            <!-- Sub menu Tournament-->
            <!-- <el-submenu index="1">
                <template slot="title">
                    <i>
                        <svg-icon class-name="menu-icon" icon-class="ic_category"/>
                    </i>
                    <span>Competición</span>
                </template>
                <el-menu-item-group title="Torneo">
                    <el-menu-item index="1-3">Formación de grupos</el-menu-item>
                </el-menu-item-group>
            </el-submenu> -->

            <el-menu-item
                v-if="hasRoleToReadClubs"
                :class="classFor('/entities/club')"
                index="/entities/club"
                :route="{name: 'clubList', query: {v: + new Date()}}"
            >
                <i>
                    <svg-icon class-name="menu-icon" icon-class="ic_club"/>
                </i>
                <span slot="title">{{$t('entities.club.plural')}}</span>
            </el-menu-item>
            <el-menu-item
                v-if="hasRoleToReadTeams"
                :class="classFor('/entities/team')"
                index="/entities/team"
                :route="{name: 'teamList', query: {v: + new Date()}}"
            >
                <i>
                    <svg-icon class-name="menu-icon" icon-class="ic_team"/>
                </i>
                <span slot="title">{{$t('entities.team.plural')}}</span>
            </el-menu-item>

            <el-menu-item
                v-if="hasRoleToReadCategories"
                :class="classFor('/entities/category')"
                index="/entities/category"
                :route="{name: 'categoryList', query: {v: + new Date()}}"
            >
                <i>
                    <svg-icon class-name="menu-icon" icon-class="ic_category"/>
                </i>
                <span slot="title">{{$t('entities.category.plural')}}</span>
            </el-menu-item>

            <el-menu-item
                v-if="hasRoleToReadPositions"
                :class="classFor('/entities/position')"
                index="/entities/position"
                :route="{name: 'positionList', query: {v: + new Date()}}"
            >
                <i class="el-icon-text">P</i>
                <span slot="title">{{$t('entities.position.plural')}}</span>
            </el-menu-item>

            <!-- <el-badge value="new" class="item"> -->
            <el-menu-item
                v-if="hasRoleToReadDocuments"
                :class="classFor('/entities/document')"
                index="/entities/document"
                :route="{name: 'documentList', query: {v: + new Date()}}"
            >
                <i class="el-icon-document"></i>
                <span slot="title">{{$t('entities.document.plural')}}</span>
            </el-menu-item>
            <!-- </el-badge> -->
            <el-menu-item
                v-if="hasRoleToReadTournament"
                :class="classFor('/entities/tournament')"
                index="/entities/tournament"
                :route="{name: 'tournamentList', query: {v: + new Date()}}"
            >
                <i class="el-icon-text">T</i>
                <span slot="title">{{$t('entities.tournament.plural')}}</span>
            </el-menu-item>

            <el-menu-item-group 
             v-if="hasRoleToReadPlayers || hasRoleToReadManagers || hasRoleToReadCoaches"
            :title="$t('entities.user.plural')">
                <!-- Users -->
                <el-menu-item
                    v-if="hasRoleToReadUsers"
                    :class="classFor('/user')"
                    index="/user"
                    :route="{name: 'userList', query: {v: + new Date()}}"
                >
                    <i class="el-icon-fa-user"></i>
                    <span slot="title">{{$t('entities.user.plural')}}</span>
                </el-menu-item>

                <!-- Players -->
                <el-menu-item
                    v-if="hasRoleToReadPlayers"
                    :class="classFor('/entities/player')"
                    index="/entities/player"
                    :route="{name: 'playerList', query: {v: + new Date()}}"
                >
                    <i>
                        <svg-icon class-name="menu-icon" icon-class="ic_player"/>
                    </i>
                    <span slot="title">{{$t('entities.player.plural')}}</span>
                </el-menu-item>

                <!-- Managers -->
                <el-menu-item
                    v-if="hasRoleToReadManagers"
                    :class="classFor('/entities/manager')"
                    index="/entities/manager"
                    :route="{name: 'managerList', query: {v: + new Date()}}"
                >
                    <i class="el-icon-fa-user"></i>
                    <span slot="title">{{$t('entities.manager.plural')}}</span>
                </el-menu-item>

                <!-- Team manager -->
                <el-menu-item
                    v-if="hasRoleToReadTeamManagers"
                    :class="classFor('/entities/teamManager')"
                    index="/entities/kteamManager"
                    :route="{name: 'teamManagerList', query: {v: + new Date()}}"
                >
                  <i class="el-icon-fa-user"></i>
                  <span slot="title"> {{$t('entities.teamManager.plural')}} </span>
                </el-menu-item>

                <!-- Coaches -->
                <el-menu-item
                    v-if="hasRoleToReadCoaches"
                    :class="classFor('/entities/coach')"
                    index="/entities/coach"
                    :route="{name: 'coachList', query: {v: + new Date()}}"
                >
                    <i class="el-icon-fa-user"></i>
                    <span slot="title">{{$t('entities.coach.plural')}}</span>
                </el-menu-item>
            </el-menu-item-group>

            <!-- Referee -->
            <!-- <el-menu-item
            v-if="hasRoleToReadReferee"
            :class="classFor('/entities/referee')"
            index="/entities/referee"
            :route="{name: 'refereeList', query: {v: + new Date()}}"
          >
            <i class="el-icon-text">R</i>
            <span slot="title">  {{$t('entities.referee.plural')}} </span>
            </el-menu-item>-->
            <!-- Field manager -->
            <!-- <el-menu-item
            v-if="hasRoleToReadFieldManager"
            :class="classFor('/entities/fieldManager')"
            index="/entities/manager"
            :route="{name: 'fieldManagerList', query: {v: + new Date()}}"
          >
            <i class="el-icon-text">FM</i>
            <span slot="title">  {{$t('entities.fieldManager.plural')}} </span>
            </el-menu-item>-->
            <!-- *************** -->
            <!-- * Version App * -->
            <!-- *************** -->
            <version-app></version-app>
        </el-menu>
    </el-aside>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VersionApp from "@/components/VersionApp";

export default {
    name: "app-menu",
    components: {
        VersionApp
    },
    data() {
        return {
            labels: {
                users: "Usuarios",
                clubs: "Clubs",
                teams: "Equipos",
                categories: "Categorias",
                players: "Jugadores",
                managers: "Managers",
                positions: "Posiciones"
            }
        };
    },
    computed: {
        ...mapGetters({
            hasRole: "auth/hasRole",
            collapsed: "shared/menuCollapsed",
            isMobile: "shared/isMobile",
            hasRoleToReadUsers: "user/hasRoleToRead",
            hasRoleToReadClubs: "entities/club/hasRoleToRead",
            hasRoleToReadTeams: "entities/team/hasRoleToRead",
            hasRoleToReadCategories: "entities/category/hasRoleToRead",
            hasRoleToReadPlayers: "entities/player/hasRoleToRead",
            hasRoleToReadManagers: "entities/manager/hasRoleToRead",
            hasRoleToReadPositions: "entities/position/hasRoleToRead",
            hasRoleToReadDocuments: "entities/document/hasRoleToRead",
            hasRoleToReadFieldManager: "entities/fieldManager/hasRoleToRead",
            hasRoleToReadReferee: "entities/referee/hasRoleToRead",
            hasRoleToReadTournament: "entities/tournament/hasRoleToRead",
            hasRoleToReadTeamManagers: "entities/team-manager/hasRoleToRead",
            hasRoleToReadCoaches: "entities/coach/hasRoleToRead"
        }),

        asideWidth() {
            if (!this.collapsed) {
                return "200px";
            }

            if (this.isMobile) {
                return "0px";
            }

            return "65px";
        }
    },

    methods: {
        ...mapActions({
            collapseMenu: "shared/collapseMenu"
        }),

        collapseMenuIfMobile() {
            if (this.isMobile) {
                this.collapseMenu();
            }
        },

        classFor(path) {
            return {
                active: this.$route.path.startsWith(path)
            };
        }
    }
};
</script>

<style scoped>
.el-menu.collapsed span {
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/shared/layout/menu.vue?0c1a301c